import { BaseDataService } from './Base/BaseDataService';
import { MeResponse } from '../Models/Me/Me';
import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { XHRRequestConfig } from '../../Libs/xhr/XHRRequest';
export interface IMeDataService {
    getMyInfo: (cts?: XHRRequestCanceler, config?: XHRRequestConfig) => Promise<MeResponse>;
}

const MeEndpoints = {
    ME: '/api/v1/back/compagnons/me',
};
class MeDataService extends BaseDataService implements IMeDataService {
    getMyInfo = (cts?: XHRRequestCanceler, config?: XHRRequestConfig): Promise<MeResponse> => {
        return this.get<MeResponse>(MeEndpoints.ME, cts, config);
    };
}

const MeDataServiceName: string = 'MeDataService';

export { MeDataService, MeDataServiceName };
